import { RelationConstructor, StoreNameType } from './types';
import RootStore from '../RootStore';
import EntityStore from '../EntityStore';

export default class HasManyRelation {
	model: Record<string, unknown[]>;
	rootStore: RootStore;
	storeName: StoreNameType;
	lkName: string;

	constructor( {
		model, rootStore, storeName, lkName,
	}: RelationConstructor ) {
		this.model = model as Record<string, unknown[]>;
		this.rootStore = rootStore;
		this.storeName = storeName;
		this.lkName = lkName;
	}

	get relatedIds() {
		return this.model[ this.lkName ];
	}

	get store(): EntityStore<never> | null {
		if ( !this.rootStore ) return null;
		const store = this.rootStore[ this.storeName ] as unknown as EntityStore<never>;
		return this.rootStore ? store : null;
	}

	get value() {
		if ( !this.store || !this.relatedIds ) { return []; }

		return this
			.relatedIds
			.map(
				relatedId => this.store?.get( relatedId as number ) || null,
			)
			.filter( related => !!related );
	}
}
